import { InputField } from '@welbe/web-design-system';
import { Button } from '@welbe/design-system';
import React, { useContext, useEffect } from 'react';
import { FiPlus, FiTrash } from 'react-icons/fi';
import { Container, InputContainer } from './BiologicalAgent.styles';
import { JobProfileContext } from 'Views/JobProfile/JobProfile.context';

export const BiologicalAgent = () => {
	const { jobRiskFactors, focusedId, setJobRiskFactors } =
		useContext(JobProfileContext);

	const index = jobRiskFactors.findIndex(
		(risk: any) => risk.jobProfileRiskFactor.id === focusedId,
	);

	const handleAdd = () => {
		const hasElement = jobRiskFactors[index]?.jobProfileRiskFactor;
		if (hasElement) {
			const exposureArr = jobRiskFactors[index].jobProfileRiskFactor.exposure;

			jobRiskFactors[index].jobProfileRiskFactor.exposure = [
				...(exposureArr ?? []),
				'',
			];

			setJobRiskFactors([...jobRiskFactors]);
		}
	};

	const handleDelete = (idx: number) => {
		const hasElement = jobRiskFactors[index]?.jobProfileRiskFactor;
		if (hasElement?.exposure?.length) {
			hasElement.exposure = hasElement.exposure?.filter(
				(_, index) => idx !== index,
			);

			jobRiskFactors[index].jobProfileRiskFactor.exposure = [
				...hasElement.exposure,
			];
			setJobRiskFactors([...jobRiskFactors]);
		}
	};

	const handleChangeAgent = (idx: number, value: string) => {
		const hasElement = jobRiskFactors[index]?.jobProfileRiskFactor.exposure;

		if (hasElement && hasElement?.length) {
			jobRiskFactors[index].jobProfileRiskFactor.exposure = hasElement.map(
				(item, index) => (idx === index ? value : item),
			);
			setJobRiskFactors([...jobRiskFactors]);
		}
	};

	useEffect(() => {
		const hasElement = jobRiskFactors[index]?.jobProfileRiskFactor?.exposure;
		if (!hasElement || !hasElement.length) {
			jobRiskFactors[index].jobProfileRiskFactor.exposure = [''];
			setJobRiskFactors([...jobRiskFactors]);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [jobRiskFactors]);

	return (
		<Container>
			{jobRiskFactors[index]?.jobProfileRiskFactor?.exposure?.map(
				(agent, index) => (
					<InputContainer key={index}>
						<InputField
							label="Sustancia o agente biológico"
							width="100%"
							onChange={(value) => handleChangeAgent(index, value)}
							value={agent}
						/>
						<Button
							width="45px"
							variant="ghost"
							onClick={() => handleDelete(index)}
						>
							<FiTrash />
						</Button>
					</InputContainer>
				),
			)}
			<Button variant="outline" width="220px" onClick={handleAdd}>
				Agregar sustancia <FiPlus />
			</Button>
		</Container>
	);
};
